module.exports = __webpack_public_path__ + "static/img/18.20dabe43.jpg";